import { 
    LOAD_RESEND_ORDERS,
    LOAD_RESEND_ORDERS_SUCCESS,
    LOAD_RESEND_ORDERS_FAIL
} from "../actions/types"

const initialState = {
    loading: false,
    fetchResendOrders: [],
    error: false
}

export default function resendOrdersReducer(state = initialState, action){
    switch(action.type){
        case LOAD_RESEND_ORDERS:
            return {
                ...state,
                loading: true
            }
        case LOAD_RESEND_ORDERS_SUCCESS:
            return {
                ...state,
                loading: false,
                fetchResendOrders: action.payload
            }
        case LOAD_RESEND_ORDERS_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload
            }
        default:
            return state
    }
}